import { useQuery } from 'react-query';
import { baseApiUrl, fetcher, ServerErrorResponse } from 'data_sources/constants';
import { TrainingInsightsCenterComplianceSummaryResponse } from '../_types';
import { QueryParams } from '../TrainingContext';

export async function getTrainingInsightMetrics(
  orgId: string,
  startDate: string,
  endDate: string,
  signal?: AbortSignal,
  onError?: (errors: ServerErrorResponse) => void
): Promise<TrainingInsightsCenterComplianceSummaryResponse> {
  try {
    const baseUrl = `${baseApiUrl()}/insights-center/v1/organizations/${orgId}/training/insights-metrics`;
    const params = new URLSearchParams({
      startDate,
      endDate,
    });
    const url = `${baseUrl}?${params.toString()}`;
    const response: TrainingInsightsCenterComplianceSummaryResponse = await fetcher({
      method: 'GET',
      url,
      options: { signal },
    });

    return response;
  } catch (error: unknown) {
    if (onError && typeof error === 'object' && error !== null && 'errorDetails' in error) {
      onError(error as ServerErrorResponse);
    }
    throw error;
  }
}

export default function useTrainingInsightMetrics(
  orgId: string,
  queryParams: QueryParams,
  options: object = {},
  onError?: (errors: ServerErrorResponse) => void
) {
  return useQuery<TrainingInsightsCenterComplianceSummaryResponse, ServerErrorResponse>(
    ['training_insight_metrics', orgId, queryParams.startDate, queryParams.endDate],
    async ({ signal }): Promise<TrainingInsightsCenterComplianceSummaryResponse> => {
      return getTrainingInsightMetrics(orgId, queryParams.startDate, queryParams.endDate, signal, onError);
    },
    {
      ...options,
      enabled: !!orgId && !!queryParams.startDate && !!queryParams.endDate,
    }
  );
}
